import { defineStore } from "pinia";
import { ref } from "vue";

// Helper function to check if a status is considered "done"
function isSuccessfulStatus(status?: string): boolean {
	return status === "confirmed" || status === "finalized";
}

export const useSignatureStore = defineStore("signature", () => {
	// data
	const signatureChannel = new BroadcastChannel("signature:status");
	const listeners = ref<{ [sig: string]: Function[] }>({});

	// methods
	function mounted() {
		signatureChannel.onmessage = ({ data: { sig, status } }) => {
			// Skip if there are no listeners for this signature
			if (!listeners.value[sig] || listeners.value[sig].length === 0) {
				return;
			}

			const successfully = !status?.err && isSuccessfulStatus(status?.confirmationStatus);

			if (successfully) {
				const [fn] = listeners.value[sig].splice(0, 1);
				if (!fn) return;

				fn();
				return;
			}

			const timeout = status?.confirmationStatus === "timeout";

			if (timeout) {
				const [fn] = listeners.value[sig].splice(0, 1);
				if (!fn) return;

				fn(new Error(status?.err))
				return
			}
		};
	}
	function addSignatureListener(sig: string, fn: Function) {
		listeners.value[sig] = listeners.value[sig] || [];
		listeners.value[sig].push(fn);
	}

	// setup
	mounted();

	return { addSignatureListener };
});
